module.exports = __webpack_public_path__ + "static/panoram-bg-ce9820712e850305fc0bd5bba0f00a42.jpg";